import Store from './interfaces/Store';
import config from '../config';
let initialized = true;
let dbPromise;
export default class IndexedDBStore extends Store {
  _db;
  constructor() {
    super();
    dbPromise = initIndexDB(config.indexedDbSchema, config.indexedDbSchemaVersion).then((db) => { this._db = db; return db; });
  }

  getDb() {
    return new Promise((resolve, reject) => {
      if (!this._db || !initialized) {
        dbPromise.then((db) => {
          resolve(db);
        });
      } else {
        resolve(this._db);
      }
    });
  }

  getAll(type) {
    return new Promise((resolve, reject) => {
      this.getDb().then((db) => {
        const transaction = db.transaction(type);
        const objectStore = transaction.objectStore(type);
        if (objectStore.getAll) {
          const request = objectStore.getAll();
          request.onerror = function (event) {
            reject(event);
          };
          request.onsuccess = function (event) {
            resolve(event.target.result);
          };
        } else {
          const result = [];
          const request = objectStore.openCursor();
          request.onsuccess = function (event) {
            const cursor = event.target.result;
            if (cursor) {
              result.push(cursor.value);
              cursor.continue();
            } else {
              resolve(result);
            }
          };
          request.onerror = function (event) {
            reject(event);
          };
        }
      });
    });
  }
  get(type, id) {
    return new Promise((resolve, reject) => {
      this.getDb().then((db) => {
        const transaction = db.transaction(type);
        const objectStore = transaction.objectStore(type);
        const request = objectStore.get(id);
        request.onsuccess = function (event) {
          resolve(event.target.result);
        };
        request.onerror = function (event) {
          reject(event);
        };
      });
    });
  }
  add(type, obj) {
    return new Promise((resolve, reject) => {
      this.getDb().then((db) => {
        const transaction = db.transaction(type, 'readwrite');
        const objectStore = transaction.objectStore(type);
        objectStore.put(obj);
      });
    });
  }
  update(type, obj) {
    return new Promise((resolve, reject) => {
      this.getDb().then((db) => {
        const transaction = db.transaction(type, 'readwrite');
        const objectStore = transaction.objectStore(type);
        objectStore.put(obj);
      });
    });
  }
  delete(type, id) {
    return new Promise((resolve, reject) => {
      this.getDb().then((db) => {
        try {
          const transaction = db.transaction(type, 'readwrite');
          const objectStore = transaction.objectStore(type);
          objectStore.delete(id);
        } catch (error) {
          console.warn(error);
        }

        // transaction.oncomplete = (event) => {
        //   const objectStore = transaction.objectStore(type);
        //   objectStore.delete(id).onsuccess((e) => {
        //     console.log(`DELETED TYPE ${type}:`, e.target.result);
        //   });
        // };
      });
    });
  }
  remove(type, id) {
    return this.delete(type, id);
  }
}

function initIndexDB(schema, schemaVersion) {
  return new Promise((resolve, reject) => {
    let indexedDBReq = indexedDB.open(config.indexedDbSchema, config.indexedDbSchemaVersion);

    indexedDBReq.onupgradeneeded = function (event) {
      initialized = false;
      console.log('Upgrade indexed db');
      const db = event.target.result;
      const objectStoreNames = config.models.map(m => m.objectStoreName);
      for (let i = 0; i < objectStoreNames.length; i++) {
        const objectStoreName = objectStoreNames[i];
        if (!db.objectStoreNames.contains(objectStoreName)) {
          db.createObjectStore(objectStoreName, { keyPath: 'id' });
        }
      }

      // resolve(db);
    };
    indexedDBReq.onsuccess = function (event) {
      initialized = true;
      console.log('onsuccess');
      const res = event.target.result;
      setTimeout(() => resolve(res), 1000);
    };
    indexedDBReq.onerror = function () {
      console.warn(event.target.errorCode);
    };
  });
}
